import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { observer } from 'mobx-react';

@observer
class GuestRoute extends React.PureComponent {
    render() {
        const { path, ...restProps } = this.props;

        if (restProps.location.pathname && path) {
            if (restProps.location.pathname === path) {
                return <Route path={path} {...restProps} />;
            }
        }

        if (restProps.location.pathname.toLowerCase().indexOf('admin') !== -1) {
            return <Redirect to='/admin/login' />;
        }
        
        return <Redirect to='/login' />;      
    }
}

export default GuestRoute;